import PhotoCaro from "../../component/PhotoCaro";
import "./homePhotoSec.scss";
import { useNavigate } from "react-router-dom";
import { MdCameraAlt, MdFavorite, MdStar, MdAutoAwesome } from "react-icons/md";

const services = [
  {
    icon: <MdCameraAlt />,
    title: "Wedding & Bridal",
    desc: "Elegant, cinematic captures of your most precious day — every emotion, every glance, beautifully framed.",
  },
  {
    icon: <MdFavorite />,
    title: "Pre-Shoots & Portraits",
    desc: "Authentic and intimate portrait sessions that reveal your true personality through the lens.",
  },
  {
    icon: <MdStar />,
    title: "Events & Celebrations",
    desc: "Birthdays, milestones, and gatherings — we capture the joy that makes every moment unforgettable.",
  },
  {
    icon: <MdAutoAwesome />,
    title: "Fashion & Lifestyle",
    desc: "Creative fashion and lifestyle sessions that blend artistry with storytelling in every frame.",
  },
];

const HomePhotoSec = () => {
  const navigate = useNavigate();

  return (
    <section id="photography" className="hp-section">
      {/* Decorative background blobs */}
      <div className="hp-blob hp-blob--left" aria-hidden="true" />
      <div className="hp-blob hp-blob--right" aria-hidden="true" />

      <div className="hp-container">
        {/* Header */}
        <div className="hp-header" data-aos="fade-up">
          <span className="hp-eyebrow">Through the Lens</span>
          <h2 className="hp-title">
            Photography <span className="hp-title--gold">Services</span>
          </h2>
          <p className="hp-subtitle">
            Every moment has a story — I capture yours with authenticity,
            passion, and an artistic eye that turns memories into timeless visuals.
          </p>
        </div>

        {/* Service Cards */}
        <div className="hp-cards" data-aos="fade-up" data-aos-delay="100">
          {services.map((service, index) => (
            <div className="hp-card" key={index} data-aos="fade-up" data-aos-delay={index * 80}>
              <div className="hp-card__icon">{service.icon}</div>
              <h3 className="hp-card__title">{service.title}</h3>
              <p className="hp-card__desc">{service.desc}</p>
              <div className="hp-card__line" />
            </div>
          ))}
        </div>

        {/* Carousel preview */}
        <div className="hp-caro-wrap" data-aos="fade-up" data-aos-delay="200">
          <PhotoCaro />
        </div>

        {/* CTA */}
        <div className="hp-cta" data-aos="fade-up" data-aos-delay="300">
          <button
            className="hp-btn"
            onClick={() => navigate("/photography")}
            aria-label="Learn more about photography services"
          >
            <span className="hp-btn__text-1">Learn More</span>
            <span className="hp-btn__text-2">Explore Gallery</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default HomePhotoSec;